import { useEffect, useState } from "react"
import Button2 from "../../../Button/Button2"
import { RuleProvider, useRule } from "./RuleReducer"
import ListOption from "../EditAutomations/ListOption"
import { useScrollTrigger } from "@mui/material"
import classes from '../CreateRule/SelectOutputs.module.css'
import ProgressBar from "./ProgressBar"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { checkSiteExists } from "../../../../../Api Methods/Api"
import { useDispatch, useSelector } from "react-redux"

const ChooseAffectedPin = ({ navigate, pins, smartLocks, createRule }) => {
    const { state, dispatch } = useRule(RuleProvider);
    const [progress, setProgress] = useState(60);
    const [message, setMessage] = useState("");
    const [linkAnotherSiteVisible, setLinkAnotherSiteVisible] = useState(false);
    const [siteID, setSiteID] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [linkedSites, setLinkedSites] = useState([]); // dynamic linked sites

    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const _dispatch = useDispatch();

    const [daysSelected, setDaysSelected] = useState(state.days_of_week)
    console.log(state.selectedRulePin)
    const Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];

    const filteredPins = pins.filter(pin =>
        pin.type !== "INPUT" &&
        pin.type !== "VIRTUAL_INPUT" &&
        !smartLocks.some(lock => parseInt(lock.outputPin) === pin.Pin) &&
        pin.Pin !== state.pinNumber
    ).map(pin => ({ ...pin, DeviceUUID: state.currentDeviceUUID || state.selectedRulePin.DeviceUUID }));

    // Handle pin selection
    const HandlePinSelected = (pin) => {
        const isSelected = state.selectedPinsToAffect.some(
            p => p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID
        );

        if (state.isAdvRule || state.supportsAdvRules){
            const action = {
                site_to: pin.DeviceUUID, 
                action_type:"CONTROL_OUTPUT",
                execution_order: state.actions.length + 1,
                delay_seconds: 0,
                control_type: "",
                target_output: String(pin.Pin)
            }

        dispatch({
            type: "SET_ADV_RULE_ACTION",
            payload: isSelected
                ? state.actions.filter(a => !(a.site_to === action.site_to && a.target_output === action.target_output))
                : [...state.actions.filter(a => !(a.site_to === action.site_to && a.target_output === action.target_output)), action]
        })

            //For UI only - values are not used in rule creation of Adv rules
            dispatch({
                type: "SET_SELECTED_PINS_TO_AFFECT",
                payload: isSelected
                    ? state.selectedPinsToAffect.filter(
                        p => !(p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID)
                    )
                    : [...state.selectedPinsToAffect, pin]
            });
        } else {
            dispatch({
                type: "SET_SELECTED_PINS_TO_AFFECT",
                payload: isSelected
                    ? state.selectedPinsToAffect.filter(
                        p => !(p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID)
                    )
                    : [...state.selectedPinsToAffect, pin]
            });
        }
    };

    const convertDaysOfTheWeek = () => {
        const selectedDayNames = daysSelected
            .slice()
            .sort((a, b) => a - b)  
            .map(dayNumber => Days[dayNumber])
            .join(',');      

        if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri") {
          return "on weekdays";
        } else if (selectedDayNames === "Sat,Sun") {
          return "on weekends";
        } else {
          return "on " + selectedDayNames.split(',').join(', ');
        }
    }



    const HandleText = () => {
        let inputType;
        switch (state.inputTypeCopy) {
            case 0: inputType = state.pinStatusOn; break;
            case 1: inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`; break;
            case 2: inputType = state.pinStatusOff; break;
            default: inputType = "unknown"; break;
        }

        if (state.isLock) inputType = "opened";
        if (state.isPulse) inputType = `temporarily ${state.pinStatusOff}`
        
        const selectedNames = state.selectedPinsToAffect.map(pin => pin.pinName).join(", ");

        const hasDayRestriction = state.days_of_week.length < 7;
        const baseText = `When ${state.pinName} is ${inputType}`;
        const dayText = hasDayRestriction ? ` ${convertDaysOfTheWeek()}` : "";
        const matchText = state.isRegularOutput && !state.isInput
            ? `, ${selectedNames}`
            : `, ${selectedNames}`;

        return `${baseText}${dayText}${matchText}`;

    };

    const HandleNavigate = (direction) => {
        if (direction === "back") {
            if (state.isInput || state.supportsOutputPulse || state.supportsInputPulse) {
                navigate(1); return;
            }
            navigate(0); return;
        }

        //check foir valid selection first
        if (state.selectedPinsToAffect.length > 0) {
            if (state.isInput || state.supportsOutputPulse || state.supportsAdvRules) {
                if (state.isAdvRule || state.supportsAdvRules){
                    navigate(5)
                } else {
                    navigate(3);
                }
            } else {
                createRule(state.inputRule, state.selectedPinsToAffect, state);
            }
        } else {
            setMessage("Please select a switch");
        }
    };

    const CheckSiteExists = async () => {
        setErrorMessage("");
        const response = await checkSiteExists({ token, client }, siteID, _dispatch);
        if (response.data) {
            if (response.data.error) {
                setErrorMessage("No site found matching that Site ID, please check and try again.");
            } else {
                const site = response.data.device;
                const deviceDetails = JSON.parse(site.deviceDetails);

                const pinsArray = Object.entries(deviceDetails)
                    .filter(([pinNumber, pin]) => pin && typeof pin === "object")
                    .map(([pinNumber, pin]) => ({
                        ...pin,
                        Pin: Number(pinNumber),
                        DeviceUUID: site.uuid
                    }))
                    .filter(pin => pin.type !== "INPUT" && pin.type !== "VIRTUAL_INPUT");

                setLinkedSites(prev => [...prev, { ...site, pins: pinsArray }]);
                setLinkAnotherSiteVisible(false);
                setSiteID("");
                dispatch({
                    type: "SET_IS_ADV_RULE",
                    payload: true
                });
            }
        }
    };

    return (
        <>
            <Dialog
                header="Please enter the Site ID of the site you want to link below"
                visible={linkAnotherSiteVisible}
                style={{ width: "40vw" }}
                onHide={() => setLinkAnotherSiteVisible(false)}
            >
                {errorMessage && <p>{errorMessage}</p>}
                <div>
                    <InputText
                        value={siteID}
                        onChange={(e) => setSiteID(e.target.value)}
                    />
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        label="Link site"
                        severity="success"
                        disabled={siteID === "" || siteID.length !== 8}
                        onClick={CheckSiteExists}
                    />
                </div>
            </Dialog>

            <div>
                <ProgressBar progress={progress} />
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
                    <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                        <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                        {/* <ListOption optionText={HandleText()} propsClassName={classes.infoBox} /> */}
                        <button className={classes.nextButton} onClick={() => HandleNavigate("next")} >{">"}</button>
                    </div>

                    <h3 style={{ color: "#6e6e6e" }}>Which switches will change state when the rule triggers?</h3>
                    {message && <p style={{ color: "red" }}>{message}</p>}

                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }}>
                        {[
                            { key: "This site", pins: filteredPins },
                            ...linkedSites.map(site => ({ key: site.key, pins: site.pins }))
                        ].map((site, siteIndex) => (
                            <div key={siteIndex} style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", marginBottom:"20px"}}>
                                <h3 style={{ color: "#6e6e6e" }}>{site.key}</h3>
                                <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                    {site.pins.map((pin, index) => (
                                        <Button2
                                            key={index}
                                            onClick={() => HandlePinSelected(pin)}
                                            style={{
                                                minWidth: "350px",
                                                minHeight: "50px",
                                                backgroundColor: state.selectedPinsToAffect.find(
                                                    p => p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID
                                                ) ? "var(--Primary-Color)" : undefined,
                                                color: state.selectedPinsToAffect.find(
                                                    p => p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID
                                                ) ? "white" : undefined,
                                                border: state.selectedPinsToAffect.find(
                                                    p => p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID
                                                ) ? "2px solid lightblue" : undefined
                                            }}
                                        >
                                            {pin.pinName}
                                        </Button2>
                                    ))}
                                </ul>
                            </div>
                        ))}
                        {state.supportsAdvRules && <Button
                            label="Affect switches on another site?"
                            rounded
                            severity="info"
                            onClick={() => setLinkAnotherSiteVisible(true)}
                        /> }
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChooseAffectedPin;